/**
 * The platform basemap of the web consoles (D797): the SAME self-hosted vector map the native apps draw — the MapLibre style
 * the api builds from its PMTiles extract at `/v1/geo/tiles/style.json` (D657, `services/vello-api/src/tiles-routes.ts`).
 * There is no key and no third-party provider: the api is the tile server, and the flavor of each theme is the api's
 * configuration (`TILES_FLAVOR_LIGHT` / `TILES_FLAVOR_DARK`), so the look changes with a redeploy of the api, never of an app.
 *
 * The web maps keep their own arithmetic (`slippy.ts`, 256 px tiles) for every pin, outline and handle; the basemap is drawn
 * underneath, at the same centre and scale. MapLibre counts zoom in 512 px tiles, so its zoom is one less than ours.
 */
/** The api path of the basemap style (the same path the native apps read, `@vello/ui-native` `MAP_STYLE_PATH`). */
export const BASEMAP_STYLE_PATH = '/v1/geo/tiles/style.json';
/** `${apiBase}/v1/geo/tiles/style.json`, with `?dark=1` for a dark surface (the flavor stays the server's decision). */
export function basemapStyleUrl(apiBase, scheme) {
    const base = apiBase.replace(/\/+$/, '');
    return scheme === 'dark' ? `${base}${BASEMAP_STYLE_PATH}?dark=1` : `${base}${BASEMAP_STYLE_PATH}`;
}
/** MapLibre's zoom for one of ours: it counts 512 px tiles, we count 256 px ones, so the same scale is one zoom lower. */
export function basemapZoom(zoom) {
    return zoom - 1;
}
/** The zoom range a web map offers over the platform basemap (vector tiles draw at any zoom; the extract stops detailing at 15). */
export const BASEMAP_ZOOM = { minZoom: 3, maxZoom: 18 };
//# sourceMappingURL=basemap.js.map